export default "__VITE_ASSET__sVpMQotY__"